import type { NotificationType } from '../../types/sharedThesaurus';

/** Types affichés dans le flux d'activité des contacts (C10 SP2, SP3). */
export const SOCIAL_NOTIFICATION_TYPES: readonly NotificationType[] = [
    'note_shared', 'note_commented', 'note_reaction', 'perimetre_shared', 'note_mention', 'contact_accepted', 'concept_aligne', 'note_versee', 'question_repondue',
];

export const ACTIVITY_PAGE_SIZE = 20;
